import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { Category } from '../types';

export class CategoryService {
  static async createCategory(
    category: Omit<Category, 'id'>
  ): Promise<Category> {
    try {
      const categoryRef = doc(collection(db, 'categories'));

      const categoryData: any = {
        ...category,
        createdAt: Timestamp.now(),
      };

      await setDoc(categoryRef, categoryData);

      return {
        ...category,
        id: categoryRef.id,
      };
    } catch (error: any) {
      throw new Error(`Failed to create category: ${error.message}`);
    }
  }

  static async getCategory(id: string): Promise<Category | null> {
    try {
      const docSnap = await getDoc(doc(db, 'categories', id));
      if (docSnap.exists()) {
        return { ...docSnap.data(), id: docSnap.id } as Category;
      }
      return null;
    } catch (error: any) {
      throw new Error(`Failed to get category: ${error.message}`);
    }
  }

  static async getAllCategories(): Promise<Category[]> {
    try {
      const q = query(collection(db, 'categories'), orderBy('order', 'asc'));
      const querySnap = await getDocs(q);
      return querySnap.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      } as Category));
    } catch (error: any) {
      throw new Error(`Failed to get categories: ${error.message}`);
    }
  }

  static async updateCategory(
    id: string,
    updates: Partial<Category>
  ): Promise<void> {
    try {
      const { id: _id, ...dataToUpdate } = updates as any;
      await updateDoc(doc(db, 'categories', id), {
        ...dataToUpdate,
        updatedAt: Timestamp.now(),
      });
    } catch (error: any) {
      throw new Error(`Failed to update category: ${error.message}`);
    }
  }

  static async deleteCategory(id: string): Promise<void> {
    try {
      await deleteDoc(doc(db, 'categories', id));
    } catch (error: any) {
      throw new Error(`Failed to delete category: ${error.message}`);
    }
  }
}
